<template>
	<div>
		<b-container>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="primary" block class="title" @click="newContractType"> {{$lang.settings.contracts.new}}</b-button>
				</b-col>
				<b-col cols="9" style="padding-right: 0px;" >
					<b-input-group >
						<b-input :placeholder="$lang.common.search"/>
						<b-input-group-append>
							<b-button variant="outline-primary">{{ $lang.common.search }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row>
			<b-table striped hover outlined :items="$store.state.contracts.contractTypes" :fields="fields" @row-clicked="editContractType" style="cursor:pointer">
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>
			</b-table>
		</b-container>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{
					key: 'name',
					label: this.$lang.settings.contracts.name
				},
				{
					key: 'sequence',
					label: this.$lang.settings.contracts.sequence
				}
			],
			breadcrumb: [{'text': this.$lang.settings.settings,'to': '/dashboard'},{'text': this.$lang.settings.contracts.title,'href': '#'}],
		}
	},
	computed: {
		...mapState(['currentUser']),
	},
	methods: {
		editContractType(contractType) {
			this.$router.push({ name: 'EditContractType', params: { contractTypeId: contractType.id } })
		},
		newContractType() {
			this.$router.push({ name: 'NewContractType' })
		}
	},
	beforeMount() {
		this.$Progress.start()
	},
	created() {
		this.$store.dispatch('fetchContractTypes')
		this.$Progress.finish();
	}

}

</script>